/**
 * 排重，去掉推荐位数据
 * @param {Array} recommendData 推荐位数据数组
 * @param {Array} originArray 需要排重的数组
 * @param {Number} needNum 需要的总条数
 * @returns {Array} filterArr 去重后数组
 */
const filterRecommendData = (recommendData, originArray, needNum) => {
    const rLen = recommendData.length;

    const filterArr = originArray.filter(each => {
        const originId = each.id;
        let flag = true;

        recommendData.forEach(item => {
            if (item.id === originId) {
                flag = false;

                return;
            }
        });

        return flag;
    });

    return filterArr.slice(0, needNum - rLen);
};

/**
 * 对信息流做单图靠前处理
 * @param {Array} listData 信息流数据
 */
const singlePicList = listData => {
    const haveThumbnail = [];
    const noThumbnail = [];

    // 先找到有缩略图的最靠前的
    listData.forEach(item => {
        if (item.thumbnail) {
            haveThumbnail.push(item);
        } else {
            noThumbnail.push(item);
        }
    });

    return [...haveThumbnail, ...noThumbnail];
};

const { formatUrl, formatImage } = require('@ifeng-fe/public_method');

/**
 * 格式化数据
 * @param {Array} dataArray 数组数据
 * @param {Number} needNum 需要的条数
 * @param {Boolean} picTileOnly 是否仅需要图片标题和链接，默认为false
 * @param {Number} picWidth 图片宽，默认大图模式，宽698
 * @param {Number} picHeight 图片高，默认大图模式，高392
 */
const formatData = (dataArray, needNum, picTileOnly = false, picWidth = 698, picHeight = 392) => {
    const simpleFormatData = [];

    // 容错处理
    if (!dataArray) {
        return [];
    }

    for (let i = 0, len = dataArray.length; i < len; i++) {
        const item = dataArray[i];
        const { id, newsTime, title, url, commentUrl, source } = item;
        let thumbnail = '';

        if (simpleFormatData.length < needNum) {
            const { thumbnails } = item;

            thumbnail =
                (thumbnails && thumbnails.image && thumbnails.image[0] && thumbnails.image[0].url) ||
                (thumbnails &&
                    thumbnails.image &&
                    thumbnails.image.value &&
                    thumbnails.image.value[0] &&
                    thumbnails.image.value[0].url);

            simpleFormatData.push({
                id: picTileOnly ? undefined : id,
                newsTime: picTileOnly ? undefined : newsTime,
                commentUrl: picTileOnly ? undefined : commentUrl,
                source: picTileOnly ? undefined : source,
                title,
                url: formatUrl(url),
                thumbnail: thumbnail ? formatImage(thumbnail, picWidth, picHeight) : thumbnail,
            });
        } else {
            // 避免造成性能浪费
            break;
        }
    }

    return simpleFormatData;
};

const handleAdDataAndStaticData = (ctx, json, allData) => {
    try {
        const statisticsData = {
            statisticsHead: allData.statisticsHead,
            statisticsBody: allData.statisticsBody,
        };

        delete allData.statisticsHead;
        delete allData.statisticsBody;

        // 处理广告碎片和静态碎片
        const adData = {};
        const staticData = {};

        for (const item of json) {
            item[0] = item[0].split(':')[0];
            if (item[2] === 'getAd') {
                if (allData[item[0]] && typeof allData[item[0]] == 'string') {
                    adData[item[0]] = encodeURIComponent(allData[item[0]]);
                } else if (item[0] === 'adHead' || item[0] === 'adBody') {
                    adData[item[0]] = encodeURIComponent('');
                } else {
                    adData[item[0]] = encodeURIComponent(`{
                            data: '${item[0]}',
                            preload: '',
                            callback: function(elm, data) {
                                console.log(data + ' 无广告');
                            }
                        }`);
                }
                delete allData[item[0]];
            } else if (item[2] === 'getStaticFragment') {
                if (typeof allData[item[0]] === 'string') {
                    staticData[item[0]] = encodeURIComponent(allData[item[0]]);
                } else {
                    staticData[item[0]] = allData[item[0]];
                }

                delete allData[item[0]];
            }
        }

        return { statisticsData, adData, staticData };
    } catch (error) {
        ctx.errorCount++;
        console.error(error);
    }
};

/**
 * 补零
 * @param {Number} number
 */
const coverZero = number => {
    return number.toString().length === 2 ? number.toString() : `0${number.toString()}`;
};

/**
 * 格式化视频时长
 * @param {String} sec
 */
const formatVideoDuration = sec => {
    let seconds = sec;

    if (typeof sec === 'string') {
        seconds = Number(sec);
    }

    let minutes = Math.floor(seconds / 60);
    const sec_left = seconds % 60;
    let hours = 0;

    if (minutes > 60) {
        hours = Math.floor(minutes / 60);
        minutes %= 60;
    }

    return hours > 0
        ? `${hours.toString()}:${coverZero(minutes)}:${coverZero(sec_left)}`
        : `${coverZero(minutes)}:${coverZero(sec_left)}`;
};

/**
 * 判断是否为数组
 * @param {*} originData
 */
const isArray = originData => {
    return Object.prototype.toString.call(originData) === '[object Array]';
};

/**
 * 格式化播放次数
 * @param {string} playTimes 播放次数
 */
const formatPlayTimes = playTimes => {
    let playTimesNum = Number(playTimes);

    if (playTimes > 10000) {
        playTimesNum = `${Math.ceil(playTimesNum / 1000) / 10}万`;
    }

    return `${playTimesNum}次播放`;
};

const homeFeedFormatData = (data, typeVal) => {
    const formatData =
        data &&
        data.map((item, index) => {
            let heatMarkWork = '';
            let picNum = 0;
            let thumbnails = '';
            let type = 'article';
            const hasVideoIcon = item.type === 'video' ? 1 : 0;

            if (item.type === 'topic' || item.type === 'special' ) {
                heatMarkWork = '专题';
                if(item.commentUrl && item.commentUrl.includes('http')) {
                    type = 'topic2';
                } else {
                    type = 'topic3';
                }
                item.articleTagColor = 10;
            } else if (item.type === 'video' || item.type === 'phvideo') {
                heatMarkWork = '视频';
                type = 'video';
                item.articleTagColor = 10;
            } else if (item.type === 'slide' || parseInt(item.page) > 1) {
                type = 'slide';
                picNum = item.page;
            }

            if (item.articleTag) {
                heatMarkWork = item.articleTag;
            }

            if (typeVal === '小说') {
                heatMarkWork = '翻阅小说';
                item.articleTagColor = 11;
            }

            if (item.thumbnail) {
                thumbnails = {
                    image: [
                        {
                            bytes: 277,
                            width: 230,
                            url: formatImage(item.thumbnail, 230, 152),
                            height: 152,
                        },
                    ],
                };
            } else if (
                item.thumbnails &&
                item.thumbnails.image &&
                item.thumbnails.image &&
                item.thumbnails.image[0] &&
                item.thumbnails.image[0].url
            ) {
                thumbnails = {
                    image: [
                        {
                            bytes: 277,
                            width: 230,
                            url: formatImage(item.thumbnails.image[0].url, 230, 152),
                            height: 152,
                        },
                    ],
                };
            } else if (
                item.thumbnails &&
                item.thumbnails.image &&
                item.thumbnails.image.value &&
                item.thumbnails.image.value[0] &&
                item.thumbnails.image.value[0].url
            ) {
                thumbnails = {
                    image: [
                        {
                            bytes: 277,
                            width: 230,
                            url: formatImage(item.thumbnails.image.value[0].url, 230, 152),
                            height: 152,
                        },
                    ],
                };
            } else if (item.posterUrl) {
                thumbnails = {
                    image: [
                        {
                            bytes: 277,
                            width: 230,
                            url: formatImage(item.posterUrl, 230, 152),
                            height: 152,
                        },
                    ],
                };
            }

            let base62Id = item.base62Id || item.commentUrl || undefined;

            if (base62Id) {
                base62Id = base62Id.toString();
                base62Id = base62Id.replace('ucms_', '');
            }

            let id = item.commentUrl || item.id || index;
            if(type === 'topic2') {
                id = (item.staticId && item.staticId.split('_').pop()) || item.commentUrl || item.id || index;
            }

            return {
                id,
                type,
                title: item.title || '',
                url: (item.type === 'topic' || item.type === 'special') ? item.wwwUrl || '' : item.url || '',
                commentUrl: item.commentUrl || '',
                thumbnails,
                articleTagColor: item.articleTagColor || '',
                source: heatMarkWork && item.commentUrl ? '' : item.source,
                articleTag: heatMarkWork,
                position: item.position || '',
                hasVideoIcon,
                picNum,
                duration: item.duration || '',
                newStyle: 'titleimg',
                base62Id,
                staticId: item.staticId,
            };
        });

    return formatData;
};

// 格式化理财超市股票数据
const dealSupermarketData = result => {
    let fundData = result.data.data.detail;
    let percent = 0;
    if (fundData.oyr && fundData.oyr != '') {
        percent = fundData.oyr;
    } else if (fundData.hlfyr && fundData.hlfyr != '') {
        percent = hmData.hlfyr;
    } else if (fundData.qua && fundData.qua != '') {
        percent = fundData.qua;
    }

    return percent;
};

/**
 * 提取searchPath
 * @param { string } searchPath
 * @return { Array<string> }
 */
const formatSearchPath = function formatSearchPath(searchPath) {
    if (!searchPath || typeof searchPath !== 'string') return [];

    const searchArr = searchPath.split(/-+/g);

    if (searchArr[searchArr.length - 1] === '') {
        searchArr.splice(searchArr.length - 1);
    }

    return searchArr;
};

/**
 * 空数组时为字符串的“[]”，转换一下
 * @param { Array } arr       : 原数组
 * @param { any } defaultValue: 默认值
 * @return { Array }
 */
const isEmptyArray = function isEmptyArray(arr, defaultValue) {
    if (typeof arr === 'string' && arr === '[]') {
        return defaultValue;
    } else {
        return arr;
    }
};

// rcp升级 判断value值是否存在
const hasDataValue = data => {
    return data && data.data && data.data.value && data.data.value ? data.data.value : [];
};

const formatVideoHomeStream = (data, type) => {
    const toLink = ['//tv.ifeng.com/c/', '//v.ifeng.com/c/'];

    return data.map(item => ({
        posterUrl: item.memberItem.image,
        title: item.title,
        source: item.weMedia ? item.weMedia.name : '',
        newsTime: item.newsTime,
        duration: item.memberItem.duration,
        guid: item.infoId,
        base62Id: item.memberItem.ucmsId,
        url: `${toLink[type]}${item.memberItem.ucmsId ? item.memberItem.ucmsId : item.memberItem.guid}`,
        type: item.memberType,
        newstype: item.memberType,
        thumbnail: item.memberItem.image,
        commentUrl: item.infoId,
        itemId: item.itemId,
        newStyle: 'titleimg',
        playTime: item.memberItem.playTime,
    }));
};

const formatMoneyStream = data => {
    return data.map(item => ({
        title: item.title,
        src:
            item.thumbnails && item.thumbnails.image && item.thumbnails.image.value.length > 0
                ? item.thumbnails.image.value[0].url
                : '',
        url: item.url,
        source: item.source,
        newsTime: item.newsTime,
        commentUrl: item.commentUrl,
    }));
};

const formatSlideMobileVideoData = data => {
    return data.map(item => ({
        title: item.title,
        src: item.thumbnail ? formatImage(item.thumbnail, 345, 175) : '',
        url: item.url,
    }));
}


module.exports = {
    filterRecommendData,
    singlePicList,
    formatData,
    handleAdDataAndStaticData,
    formatVideoDuration,
    isArray,
    formatPlayTimes,
    homeFeedFormatData,
    dealSupermarketData,
    formatSearchPath,
    isEmptyArray,
    hasDataValue,
    formatVideoHomeStream,
    formatMoneyStream,
    formatSlideMobileVideoData
};
